<template>
  <v-app>
    <Barra/>
    <v-main class="mx-4 mb-4">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Barra from './components/Barra';

export default {
  name: 'App',

  components: {
    Barra,
  },

  data: () => ({
    //
  }),
};
</script>
